<!-- <div #animatedDigit class="animated-digit">
    <span>{{digit}}</span>
  </div> -->
<!-- <svg:g> -->
  <text class="animated-digit" x="50%" y="50%" text-anchor="middle" stroke="#51c5cf" stroke-width="0px" dy=".3em"
    style="stroke-size:0;font-size: 8px;">{{digit}}</text>
<!-- </svg:g> -->
